import styled, { css } from "styled-components";
import { PositionProps, LayoutProps, position, layout } from "styled-system";
import { Tabs, Box, Typography, Tab, Panel } from "@bca/ui-library";

import { SalesPageLayout, SalesPageTitle } from "./SalesPageLayout";
import { LoadingTabButton } from "./TabButtons";
import SalesCardLoadingPlaceholder from "./SalesCardLoadingPlaceholder";

const BoxWithCss = styled(Box)<any>`
  ${css}
`;

const BackgroundMasker = styled.div<
  PositionProps & LayoutProps & { css?: string }
>`
  background: #091535;
  position: absolute;
  z-index: 1;
  width: 6px;
  height: 73px;
  ${position}
  ${layout}
  ${(props) => props.css}
`;

interface SalesPageLoadingProps {
  user?: { firstName: string; lastName: string };
  idToken?: string;
  isToUseAuthZero: boolean;
  isAuthenticated: boolean;
  logoutUrl?: string;
  week: Date[];
}

const SalesPageLoading: React.FunctionComponent<SalesPageLoadingProps> = ({
  user,
  idToken,
  isToUseAuthZero,
  isAuthenticated,
  logoutUrl,
  week,
}: any) => {
  return (
    <SalesPageLayout
      user={user}
      idToken={idToken}
      isToUseAuthZero={isToUseAuthZero}
      isAuthenticated={isAuthenticated}
      logoutUrl={logoutUrl}
    >
      <Tabs>
        <div
          style={{
            backgroundImage:
              "linear-gradient(to bottom, rgba(7, 11, 22, 0) 35%, rgba(7, 11, 22, 0) 130%), linear-gradient(to bottom, #091535, #091535)",
          }}
        >
          <SalesPageTitle></SalesPageTitle>
          <BoxWithCss
            maxWidth={["100%", "calc(100% - 48px)", "976px", "976px"]}
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              backgroundImage:
                "linear-gradient(to bottom, rgba(7, 11, 22, 0) 35%, rgba(7, 11, 22, 0) 130%), linear-gradient(to bottom, #091535, #091535)",
              paddingLeft: "0",
              margin: "0 auto",
              height: "73px",
            }}
            marginX="3px"
            css={`
              @keyframes loading {
                100% {
                  transform: translateX(120%);
                }
              }
              position: relative;
              background-color: rgba(126, 154, 179, 0.1);
              &:after {
                content: "";
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(
                  to right,
                  rgba(0, 0, 0, 0),
                  rgba(126, 154, 179, 0.2),
                  rgba(0, 0, 0, 0)
                );
                transform: translateX(-120%);
                animation: 2s loading ease-in-out infinite;
              }
            `}
          >
            <BackgroundMasker left={134} bottom={0}></BackgroundMasker>
            <BackgroundMasker left={274} bottom={0}></BackgroundMasker>
            <BackgroundMasker left={414} bottom={0}></BackgroundMasker>
            <BackgroundMasker left={554} bottom={0}></BackgroundMasker>
            <BackgroundMasker left={694} bottom={0}></BackgroundMasker>
            <BackgroundMasker left={834} bottom={0}></BackgroundMasker>
            {week.map((day, index) => {
              return (
                <Tab key={index}>
                  <LoadingTabButton>
                    <Typography variant="body">{""}</Typography>
                  </LoadingTabButton>
                </Tab>
              );
            })}
          </BoxWithCss>
        </div>
        <Panel>
          <SalesCardLoadingPlaceholder></SalesCardLoadingPlaceholder>
          <SalesCardLoadingPlaceholder></SalesCardLoadingPlaceholder>
          <SalesCardLoadingPlaceholder></SalesCardLoadingPlaceholder>
        </Panel>
      </Tabs>
    </SalesPageLayout>
  );
};

export default SalesPageLoading;
